import { interpolateContentToJSX } from '../../../helpers';
import { useContent } from '../../../hooks/use-content';
import { usePageScroller } from '../../../hooks/use-page-scroller';
import { ServiceThemeEditorAnnexOnePage } from './ServiceThemeEditorAnnexOnePage';

export const ServiceThemeEditorPage = () => {
  const content = useContent();
  const contentKeyPage = content.t('portal.termsOfUse.manufacturerServices.themeEditor.page');

  const jsxContent: JSX.Element[] = interpolateContentToJSX(contentKeyPage, [
    {
      selector: 'annex-link',
      element: ServiceThemeEditorAnnexOnePage,
      elementProps: {},
    },
  ]);

  usePageScroller(contentKeyPage);

  // need the fragment, otherwise the page will not render
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{...jsxContent}</>;
};
